<template>
  <div ref="curComponentRef" class="xy-double-faced-image flip-card" :class="{ 'is-flipped': isFlipped }">
    <div class="flip-card-inner">
      <div class="flip-card-front" :style="getCardStyle(false)">
        <img class="bg-image" :src="fSrc" alt="front img" :style="{ objectFit: props.fit }" />
        <div v-if="prize" class="flip-card-front-text">
          <p :style="{ color: prize.color }">{{ prize.text }}</p>
        </div>
      </div>
      <div class="flip-card-back" :style="getCardStyle(true)" @click.stop="null">
        <img class="bg-image" :src="bSrc" alt="front img" :style="{ objectFit: props.fit }" />
        <div v-if="prize" class="flip-card-front-text">
          <template v-for="vo in prize.srcVo" :key="vo">
            <img v-if="vo.src" :src="vo.src" :style="{ width: prize.width, height: prize.height, top: prize.top }" alt="prize" />
            <p :style="{ position: 'absolute', color: prize.fontColor, fontSize: prize.fontSize, top: prize.fontPositionY, left: prize.fontPositionX }">{{ 'x' + (vo.num || 0) }}</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { info, defaultProps } from './config'
import useComponentRef from '@/packages/plugins/hook/useComponent'
import EventBus from '@/h5/utils/eventBus'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)

const fSrc = ref(props.frondSrc)
const bSrc = ref(props.backSrc)
const isFlipped = ref(false)
const prize = ref({})
const activeStyle = ref({})
const defaultStyle = ref({})

const componentRef = useComponentRef()
const curComponentRef = ref()

watch(
  () => props.frondSrc,
  (newVal) => {
    fSrc.value = newVal
  }
)

watch(
  () => props.backSrc,
  (newVal) => {
    bSrc.value = newVal
  }
)

// 卡片样式
const getCardStyle = (isFlip) => {
  const style = isFlip ? activeStyle.value : defaultStyle.value
  const styleItem = {
    ...style,
    borderRadius: defaultStyle.value?.borderRadius
  }
  return styleItem
}

const start = async (index) => {
  // 获取最新数据
  if (props.raffleId) {
    const data = await componentRef.getComponentRef(props.raffleId).getRaffleData()
    if (data) {
      // 根据index取出对应数据
      prize.value = data.prizes[index]
    }
  }
  isFlipped.value = true
}

const reset = () => {
  isFlipped.value = false
}

onMounted(async () => {
  // 找到绑定的组件，获取数据defaultStyle、activeStyle、prizes
  if (props.raffleId) {
    // 订阅&&回调
    EventBus?.$on('Raffle_Btn_Init', async () => {
      EventBus?.$off('Raffle_Btn_Init')
      const uuid = curComponentRef.value.getAttribute('id') || ''
      componentRef.getComponentRef(props.raffleId).saveCardID(uuid)
      const data = await componentRef.getComponentRef(props.raffleId).getRaffleData()
      console.log(data)
      if (data) {
        defaultStyle.value = data.defaultStyle
        activeStyle.value = data.activeStyle
        prize.value = data.prizes[props.index]
        isFlipped.value = data.initFlippedCards?.includes(props.index)
      }
    })
  }
})

defineExpose({
  start,
  reset
})
</script>

<style lang="scss" scoped>
.xy-double-faced-image {
  width: 100%;
  height: 100%;
  position: relative;
}
.flip-card {
  background-color: transparent;
  perspective: 1000px;
  cursor: pointer;
  text-align: center;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  -webkit-transform: translate3d(0, 0, 0);
}
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  background-color: transparent;
}

.flip-card.is-flipped .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card.is-active {
  box-shadow: 0 0 10px rgba(255, 215, 0, 0.8);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flip-card-front {
  color: black;

  &-text {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    img {
      position: relative;
    }
  }
}

.flip-card-back {
  color: white;
  transform: rotateY(180deg);
}

img {
  max-width: 100%;
  max-height: 100%;
}

.flex-row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flip-card-front-text {
  position: relative;
}
.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1; /* 置于底层 */
}
</style>
